<div>
	<div class="d-flex align-items-center">
		<seira-page-title class="w-100 align-items-center">
			<div class="d-flex justify-content-between align-items-center">
				<div
					style="color: #728187; font-weight: 400; font-size: 24px !important">
					Dados meteorológicos
					<i class="dot bg-primary dot-space"></i>
					Estações pluviométricas
				</div>
				<div class="d-flex justify-content-end align-items-center flex-wrap">
					<div
						class="d-flex justify-content-end align-items-center"
						style="height: 100%">
						<seira-public-a
							class="d-flex align-items-center text-primary fs-6 fw-light mx-2 gap-xl-1"
							(click)="irParaPaginaEnvioDadosMassivo()">
							<i class="ph-info-fill ms-1"></i> Para mais dados, consulte aqui
						</seira-public-a>
					</div>
					<div
						class="d-flex justify-content-end align-items-center"
						style="height: 100%">
						<seira-public-page-about
							class="size-about"
							[textosInformativos]="
								informacoesGerais
							"></seira-public-page-about>
					</div>
				</div>
			</div>
		</seira-page-title>
	</div>

	<seira-estacoes-pluviometricas></seira-estacoes-pluviometricas>
	<ng-template #legendaMapaMobile>
		<seira-legenda-estacoes></seira-legenda-estacoes>
	</ng-template>
	<ng-container #dynamicComponentContainer></ng-container>
	<div
		class="d-flex w-100 justify-content-center"
		*seiraIfViewportSize="'desktop'">
		<div class="seira-info-wrap">
			<seira-info-gerais
				id="informacoes-gerais"
				[textosInformativos]="informacoesGerais">
			</seira-info-gerais>
		</div>
	</div>
</div>
